import React from "react";
import { StyledNotificationInner } from "../../dashboard.style";

// notification content:
// Integration success [success]
// Integration failure [warning]
// Segment active [success]
// Trial nearing end [info]
// Trial over [warning]
// Payment complete [success]
// Plan cancellation [warning]

const NotificationInner = ({ type, content, CTA }) => {
	return (
		<StyledNotificationInner type={type}>
			<h3>{content.title}</h3>
			<p>{content.massage}</p>
			<button type="button" onClick={CTA}>
				{content.btnLabel}
			</button>
		</StyledNotificationInner>
	);
};
export default NotificationInner;
